import React from 'react';
import { GiftOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Tag } from 'antd';

const ReferButton = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/referrals');
  };

  return (
    <div onClick={handleClick} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }} data-testid="refer-button">
      <GiftOutlined />
      <span>{t('referrals.link')}</span>
    </div>
  );
};

export default ReferButton;



